import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Observable, distinctUntilChanged, fromEvent, map, merge, takeUntil } from 'rxjs';
import { MatFormFieldControlImpl } from '../../ng-material-impl/mat-form-field-control.impl';

@Component({
  selector: 'ss-text-control',
  templateUrl: './text-control.component.html',
  styleUrls: ['./text-control.component.css'],
  providers: [
    {
      provide: MatFormFieldControl,
      useExisting: TextControlComponent
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextControlComponent extends MatFormFieldControlImpl<string> implements OnInit {


  @ViewChild('inputRef')
  private _inputRef!: ElementRef<HTMLInputElement>

  readonly touchedSubject = this._formControlService.touchedSubject;
  readonly valueSubject = this._formControlService.valueSubject;
  readonly readOnlyObs = this._formControlService.readOnlyObs;

  constructor(
    ngControl: NgControl
  ) {

    super('text')
  }

  ngOnInit(): void {
  }

  onContainerClick(event: MouseEvent): void {

    this._inputRef.nativeElement.focus();

  }

  ngAfterViewInit() {
    this._formControlService.htmlElementSubject.next(this._inputRef.nativeElement);
    const changeObs = fromEvent(this._inputRef.nativeElement, 'change')

    const inputKeyStream = fromEvent(this._inputRef.nativeElement, 'keyup') as Observable<KeyboardEvent>
    merge(inputKeyStream, changeObs)
      .pipe(
        map((evParams) => {
          const htmlInputElement = evParams.target as HTMLInputElement;
          const value = htmlInputElement.value;
          return value;
        }),
        distinctUntilChanged(),
        takeUntil(this._destroy),
      )
      .subscribe((value) => {

        this.valueSubject.next(value);

      })

  }

  ngOnDestroy() {

    const htmlInputElement = this._inputRef.nativeElement;
    const value = htmlInputElement.value;

    if (value !== this.valueSubject.value) {
      this.valueSubject.next(value)
    }

    this._destroy.next();
    this._destroy.complete();
  }
}
